import { StatsigInitializeValues } from '@eventbrite/statsig';
import { History } from 'history';
import React, { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { Store } from 'redux';
import './app.scss';
import { ConnectedStatsigSynchronousProvider } from './containers/StatsigProvider';
import getRoutes from './routes';
import { CheckoutState } from './state';

export const CheckoutWidgetApp: FunctionComponent<{
    statsigInitializeValues: StatsigInitializeValues;
    store?: Store<CheckoutState>;
    history?: History;
}> = ({ statsigInitializeValues, store, history }) => (
    <Provider store={store}>
        <ConnectedStatsigSynchronousProvider
            initializeValues={statsigInitializeValues}
        >
            <Router history={history} routes={getRoutes()} />
        </ConnectedStatsigSynchronousProvider>
    </Provider>
);

export { CheckoutWidgetApp as default };
